/**
 * Single owner of client-side CSV building for every admin export (the payouts
 * export, the MKT-745 coupon-batch export). Before this the payouts page carried
 * a private copy of the escaping; centralising it keeps the CSV-injection guard
 * in exactly one place.
 *
 * A leading `=`, `+`, `-`, `@`, tab, or CR makes Excel/Sheets execute a cell
 * built from user-controlled fields; prefixing a single quote forces the cell to
 * render as text. The value is then wrapped in quotes with inner quotes doubled
 * so field delimiters and newlines stay inside the field.
 */
export const escapeCsvCell = (raw: string): string => {
  const guarded = /^[=+\-@\t\r]/.test(raw) ? `'${raw}` : raw

  return `"${guarded.replace(/"/g, '""')}"`
}

/** Join a header + body matrix into a CSV string, escaping every cell. */
export const rowsToCsv = (rows: string[][]): string =>
  rows.map((row) => row.map(escapeCsvCell).join(',')).join('\n')
